import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["KdAdSlot"] */ "/vercel/path0/src/components/ads/KdAdSlot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/apt/detail/carousel/CarouselNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/apt/LeadForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AdLeadSlot","AdStickyCta","useAdVariant"] */ "/vercel/path0/src/components/cl/AdVariant.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/cl/SiteBlogCta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/cl/TalkCta.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ds/v3/region-rd2.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/cl/cl.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/apt/v3/apt-v3.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ds2/CardImg.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ds2/ds2.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/home/carousel/home-carousel.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/region-doc/region-doc.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/region-doc/RegionTalk.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/search/KdSearchBox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/search/PopularRegionSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/share/ShareDock.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/thumb/Thumb.tsx");
